import About from 'components/pages/About/About';
import { buildPage } from 'utils/pageHelper';

export default buildPage(About, {
  fullPage: true,
  metaData: {
    title: 'About us',
    description:
      'Qmee is a digital rewards platform that allows users to earn cash rewards for their purchases & opinions, and gives brands a technology solution that gets faster, more accurate answers.',
  },
});
